import { createContext } from "react";
import type { TrackingContext } from "./types";

export const trackingContext = createContext<TrackingContext>({});
